<template>
	<div class="container-fluid p-5">
		<!-- <h1>Report</h1> -->
		<div class="text-center">
			<button class="btn btn-orange" @click="getReport" v-if="!report">
				Get Report
			</button>
		</div>
		<div v-if="report">
			<markdown :source="report" v-if="report" />
		</div>
	</div>
</template>

<script setup>
	import { ref } from "vue"
	// import { hasTokenIssue, handleTokenIssue } from "@/utils/tokenIssue"
	import { fetchWithAuth } from "@/utils/api-client"
	// import { useTokenStore } from "@/stores/token"
	import { startLoading, stopLoading } from "@/utils/loaderBus"
	import Markdown from "@/components/Markdown.vue"

	// const tokenStore = useTokenStore()

	const report = ref("")

	const getReport = async () => {
		try {
			startLoading()
			const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
			const response = await fetchWithAuth("/api/nutrition-report", {
				headers: {
					"User-Timezone": tz,
					// Authorization: `Bearer ${tokenStore.token}`,
				},
			})
			stopLoading()
			// if (hasTokenIssue(response)) {
			// 	handleTokenIssue(response)
			// } else {
			const data = await response.json()
			console.log(data)
			report.value = data.ai
			// }
		} catch (error) {
			console.error(error)
		} finally {
			stopLoading()
		}
	}
</script>

<style lang="less" scoped>
	.btn-orange {
		background-color: #ff6400;
		color: white;
		font-size: 36px;

		&:hover {
			background-color: #ff6400;
			color: white;
		}
	}
</style>
